<template>
  <div class="page">
    <div
      v-for="(v, pindex) in page"
      :id="`Page2Pdf4Data${v}`"
      :key="pindex"
      class="pdf-box mb20"
    >
      <div>
        <PdfTop
          :title="'群体对比'"
          :search-params="searchParams"
          :classroom-name="classroomName"
          :sex-name="sexName"
          :age-name="ageName"
        />
        <div class="con-box">
          <MainTitle title="体格发育对比" tag="BMI分布" />
          <div
            v-if="
              (v === 1 && searchParams.classroomIds.length > 14) ||
                searchParams.classroomIds.length <= 14
            "
            class="clearfix mt20"
          >
            <BasePanel :title="'较瘦'" class="chart-item">
              <div>
                <BarHorizontal
                  v-if="list0.length"
                  :data-list="list0[0].details"
                />
              </div>
            </BasePanel>
            <BasePanel :title="'正常'" class="chart-item no-margin-r">
              <div>
                <BarHorizontal
                  v-if="list1.length"
                  :data-list="list1[0].details"
                />
              </div>
            </BasePanel>
          </div>
          <div
            v-if="
              (v === 2 && searchParams.classroomIds.length > 14) ||
                searchParams.classroomIds.length <= 14
            "
            :class="{mt20: searchParams.classroomIds.length > 14}"
            class="clearfix"
          >
            <BasePanel :title="'超重'" class="chart-item">
              <div>
                <BarHorizontal
                  v-if="list2.length"
                  :data-list="list2[0].details"
                />
              </div>
            </BasePanel>
            <BasePanel :title="'肥胖'" class="chart-item no-margin-r">
              <div>
                <BarHorizontal
                  v-if="list3.length"
                  :data-list="list3[0].details"
                />
              </div>
            </BasePanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupCompareBMIDistribute,
  getClassList
} from '@/api/teachingProtection/assessment'
import PdfTop from './PdfTop.vue'
import MainTitle from './MainTitle.vue'
import BasePanel from './BasePanel.vue'
import BarHorizontal from './BarHorizontal.vue'

export default {
  components: {
    PdfTop,
    MainTitle,
    BasePanel,
    BarHorizontal
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      frirstChartData: {},
      barDataArray: [],
      colorList: ['#F87A52', '#FFA100', '#6DD400', '#3A91FF', '#A35DFF'],
      classroomName: '',
      sexName: '',
      ageName: '',
      dataLength: 0,
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      page: 1
    }
  },
  created() {
    if (this.searchParams.classroomIds.length > 14) {
      this.page = 2
    }
    if (!this.searchParams) return
    let params = this.searchParams
    console.info(this.searchParams)
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    groupCompareBMIDistribute({ ...params, weightLastType: 100 }).then(
      (res) => {
        this.list0 = res.data.barChart || []
      }
    )
    groupCompareBMIDistribute({ ...params, weightLastType: 101 }).then(
      (res) => {
        this.list1 = res.data.barChart || []
      }
    )
    groupCompareBMIDistribute({ ...params, weightLastType: 102 }).then(
      (res) => {
        this.list2 = res.data.barChart || []
      }
    )
    groupCompareBMIDistribute({ ...params, weightLastType: 103 }).then(
      (res) => {
        this.list3 = res.data.barChart || []
      }
    )
  },
  methods: {
    getEle() {
      const arr = []
      for (let i = 0; i < this.page; i++) {
        arr.push(document.getElementById(`Page2Pdf4Data${i + 1}`))
      }
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 20px 30px;
    min-height: 700px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 513px;
  min-height: 330px;
  margin-right: 103px;
}
.no-margin-r {
  margin-right: 0px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
